import { LICENSE_SETTINGS_INITIAL_STATE } from './chunk-OQYBQD74.mjs';
import { USER_INITIAL_STATE, ROLE_INITIAL_STATE } from './chunk-HJ42I75R.mjs';
import { INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID, INITIAL_STATE_BASE_INTERFACE } from './chunk-3YIOW4BW.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/settings/selectedMode/initialStates.ts
var DAY_OPERATIONAL_HOURS_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID), {
  generalSettingsId: 0,
  day: "monday" /* MONDAY */,
  startTime: "",
  endTime: "",
  createdAt: null,
  updatedAt: null,
  deletedAt: null
});
var OPERATIONAL_DAY_HOURS_INITIAL_STATE = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: []
};
var LOCK_SCREEN_SETTINGS_INITIAL_STATE = {
  id: "",
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  organizationId: 0,
  locationId: 0,
  showGiftCardOptionsButton: false,
  announcementTitle: "",
  announcementDescription: "",
  showFreshSheetTab: false,
  showSeatingLayoutTab: false,
  showEmployeesTab: false,
  showLocationsTab: false
};
var ROLES_INITIAL_STATE = {};
var DASHBOARDS_INITIAL_STATE = {};
var PAYMENTS_SETTINGS_INITIAL_STATE = {
  id: 0,
  organizationId: 0,
  locationId: 0,
  confirmDrawerStartingBalance: true,
  dueExceedsPreAuth: false,
  defaultPreAuthAmount: 0,
  tipPayoutMethod: "manual" /* MANUAL */,
  tipDistribution: "individual" /* INDIVIDUAL */,
  splitTipInterval: null,
  shareBy: null,
  sharingRules: null,
  rolePoolContributors: null,
  rolePoolRecipients: null,
  serviceCharges: {},
  defaultTipInput: "tipAmount" /* TIP_AMOUNT */,
  automatedBatching: false,
  batchTime: "",
  printChecksOnCloseOrder: false,
  forceAllPaidOrdersToTipPending: false,
  requireManualClosingPostTip: false,
  enableEGiftIntegration: false,
  eGiftCardMerchantId: null,
  eGiftCardLocationId: null,
  dualPricing: false,
  listPrice: "cash" /* CASH */,
  cardCashPrice: 0,
  acceptCashPayments: true,
  cashBackgroundColor: "",
  cashTextColor: "",
  cashPrintMerchantCopy: false,
  cashPrintReceipt: false,
  acceptCreditCardPayments: true,
  creditCardBackgroundColor: "",
  creditCardTextColor: "",
  creditCardAllowTips: true,
  creditCardAutoConfirmTip: false,
  creditCardPrintMerchantCopy: false,
  creditCardPrintReceipt: false,
  creditCardPrintTip: false,
  acceptHousePayments: true,
  houseBackgroundColor: "",
  houseTextColor: "",
  houseAllowTips: true,
  houseAutoConfirmTip: false,
  housePrintMerchantCopy: false,
  housePrintReceipt: false,
  housePrintTip: false,
  enableGiftCardPayments: true,
  giftCardBackgroundColor: "",
  giftCardTextColor: "",
  giftCardAllowTips: true,
  giftCardAutoConfirmTip: false,
  giftCardPrintMerchantCopy: false,
  giftCardPrintReceipt: false,
  giftCardPrintTip: false,
  customTenders: {}
};
var REGISTER_SETTINGS_INITIAL_STATE = {
  id: 0,
  organizationId: 0,
  locationId: 0,
  defaultRestaurantMode: "qsr" /* QSR */,
  seating: false,
  courses: {},
  specialTags: {},
  coursing: false,
  autoTriggering: false,
  allowForTableButton: false,
  showSeatOneDescription: true,
  defaultMenuTypeTimes: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  },
  customizerPartitions: "quarters" /* QUARTERS */,
  customizerShape: "circle" /* CIRCLE */,
  showSendItemsModal: false,
  modifierTags: {},
  discountReasons: {},
  openItemTypes: {},
  showModTagBar: false,
  showConfirmPopUpOnClearUnsentWithinAnItem: false,
  isCateringAvailable: false,
  isDeliveryAvailable: false,
  isDineInAvailable: false,
  isToGoAvailable: false,
  useCleaningStatusOnTableLayout: false,
  allowOpenTabsOnTableLayout: false,
  assignOrderTag: false,
  sendOrderToKitchenTrigger: "Payment Completed" /* PAYMENT_COMPLETED */,
  showConfirmPopupToRemoveItem: false,
  showSeatsOnTableLayout: true,
  showTimerOnTableLayout: true,
  defaultMenuTypeId: 0,
  orderSeatTags: {},
  ticketSeatBar: "none" /* NONE */,
  splittingFee: null,
  showConfirmPopUpWhenSendingItemsInSeatView: false,
  enableDragDropForSeatPopover: false,
  enforceItemGroupOrderForCombos: false,
  setGuestCountToZeroOnToGoOrders: false,
  setGuestCountToZeroWhenNoTable: false,
  showGuestCount: false,
  defaultGuestCountOnNewOrder: false,
  showOrderDetailsForNewOrderQsr: false,
  showOrderDetailsForNewOrderTsr: true,
  showOrderDetailsForDefaultNewOrder: false,
  showSentItemModificationsOnRegisterTicket: false,
  qsrSendAndPayActionButtons: "both" /* BOTH */,
  coursingMode: "predefined" /* PREDEFINED */,
  seatingMode: "prompt" /* PROMPT */,
  showConfirmPopUpOnLeaveIncompleteItem: false,
  showHotButtonToggle: false,
  groupRounds: false,
  prepStationForFireTicketId: null,
  attachNoSeatToToGo: false,
  showPopUpOnNavigateIfItemsOnTicketNotSentToKitchen: false,
  showIndicatorWhenItemsOnTicketNotSentToKitchen: false,
  ads: {},
  receiptScreenTimeout: 0,
  requireClientSignature: false,
  payThroughCfdOnly: false,
  promptStarRatings: false,
  darkMode: false,
  promptPrintReceipt: false,
  isFacebookActive: false,
  isXActive: false,
  isInstagramActive: false,
  facebookAccount: "",
  xAccount: "",
  instagramAccount: "",
  placeholderBackground: "",
  adTextBackground: "",
  mediaLinksBackground: "",
  showTippingOptionsAtCheckout: false,
  showCfdTipSelectionOnRegister: true,
  defaultSuggestedTip: "suggestedTip1",
  suggestedTip1: 0,
  suggestedTip2: 0,
  suggestedTip3: 0,
  requireNoOpenOrders: false,
  requireNonCashTips: false,
  requireServerBankSettlement: false,
  netNonCashTipsOnSettlement: false,
  requireCashtipReporting: false,
  requireDrawerSettlement: false,
  displayTipsDueInHeader: false,
  zeroTipsDueOnClockOut: false,
  showNotificationMessageForPrinterErrors: false,
  showPrinterStatusNotifications: false,
  firePositionOnRegisterTicket: "top",
  keepTipPendingOrdersAssociatedToTable: false,
  enableMapLayoutDragAndDrop: false,
  showTableBorderForLoggedInUsersOrders: false,
  seatManagementButtonFunction: "seatTagsOnly" /* SEAT_TAGS_ONLY */,
  showDoneButton: false,
  printHeldItems: false,
  autoSettleDrawerId: null
};
var TICKET_SETTINGS_INITIAL_STATE = {
  id: 0,
  locationId: 0,
  organizationId: 0,
  showTimestamps: true,
  showSendCourseButton: true,
  showPriceFree: false,
  displayDefaultModifiers: true,
  showModifierItemPrice: false,
  modifierItemDisplayMode: "vertical" /* VERTICAL */,
  hideModGroupTitles: false,
  autoCollapseLineItems: true,
  noForDeselectedDefaultModifiers: false,
  groupSameModItems: true,
  addSubForMultiSelectOff: true,
  separateSentItems: false
};
var KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE = {
  status: "inactive" /* INACTIVE */,
  order: 1,
  prepend: "",
  append: "",
  justify: "left" /* LEFT */,
  fontSize: "a11" /* A11 */,
  fontWeight: "normal" /* NORMAL */,
  color: "black" /* BLACK */,
  line: "none" /* NONE */,
  noLineBreak: false
};
var KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE = {
  status: "inactive" /* INACTIVE */,
  order: 1,
  justify: "left" /* LEFT */,
  fontSize: "a11" /* A11 */,
  fontWeight: "normal" /* NORMAL */,
  color: "black" /* BLACK */
};
var KITCHEN_TICKET_CUSTOMIZING_RECEIPT_INITIAL_STATE = {
  updateStatus: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  orderType: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  orderName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  orderNumber: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  table: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  placedBy: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  server: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  dateAndTime: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  stationName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  address: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  guestCount: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  time: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE
};
var GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE = {
  orderType: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  orderName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  orderNumber: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  table: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  deliveryAddress: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  server: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  dateAndTime: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  organizationName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  locationName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  locationAddress: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  checkName: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE,
  time: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE
};
var KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_INITIAL_STATE = {
  itemNameAndQuantity: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE,
  seatNumber: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE,
  seatTags: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE,
  modifiersInfo: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE
};
var KITCHEN_TICKET_PREP_STATION_VERSION = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  prepStationId: 0,
  printUnfiredItems: false,
  printModifications: false,
  showCourses: false,
  showOrderTags: false,
  headerBlankSpace: "1.00" /* ONE */,
  orderTagColors: "black" /* BLACK */,
  displayDefaultModifiers: false,
  consolidateByItem: false,
  hideModGroupTitles: false,
  groupSameModItems: false,
  addSubForMultiSelectOff: false,
  noForDeselectedDefaultModifiers: false,
  modifierItemDisplayMode: "vertical" /* VERTICAL */,
  ticketHeader: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  ticketBody: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_INITIAL_STATE,
  ticketFooter: KITCHEN_TICKET_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  orderTagsFontSize: "a11" /* A11 */,
  elementSpacing: "0" /* ZERO */,
  groupBySeat: false,
  updateOrderVoidText: "",
  updateOrderNewText: "",
  updateOrderTextPosition: "Before" /* BEFORE */,
  updateOrderTextColor: "black" /* BLACK */,
  showCourseName: false,
  changeNoSeatTextInToGoOrders: false,
  printOrderQr: false
});
var KITCHEN_TICKET_SETTINGS_INITIAL_STATE = {
  id: 0,
  locationId: 0,
  organizationId: 0,
  prepStationVersions: {}
};
var GUEST_CHECK_SETTINGS_INITIAL_STATE = {
  id: 0,
  displayDefaultModifiers: false,
  hideModGroupTitles: false,
  groupSameModItems: false,
  addSubForMultiSelectOff: false,
  noForDeselectedDefaultModifiers: false,
  ticketHeader: GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  ticketFooter: GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  showLogo: false,
  courseOrder: [],
  modifierItemDisplayMode: "vertical" /* VERTICAL */,
  sortItemsBy: "registerCourse" /* REGISTER_COURSE */,
  secondSortItemsBy: "alphabetical" /* ALPHABETICAL */,
  fontSize: "a11" /* A11 */,
  printPriceForFreeModItems: false,
  onlyPrintModItemsWithPrice: false,
  showItemUnitPrice: false,
  taxIndicatorPosition: "Before" /* BEFORE */,
  taxIndicatorColor: "black" /* BLACK */,
  taxIndicator: null,
  taxExemptIndicator: null,
  showTaxIndicator: false,
  elementSpacing: "0" /* ZERO */,
  fontWeight: "normal" /* NORMAL */,
  customTypeNameDineIn: null,
  customTypeNameCurbside: null,
  customTypeNameToGo: null,
  customTypeNameDelivery: null,
  customTypeNamePickup: null,
  showFooterDescription: false,
  footerDescription: null,
  showTaxesIndividually: false,
  printOrderQr: false
};
var GUEST_RECEIPT_SETTINGS_INITIAL_STATE = {
  id: 0,
  showCheckTotals: true,
  footerDescription: "",
  showFooterDescription: true,
  showItems: true,
  showSuggestedTips: true,
  showTipTotalLines: true,
  tipOption1: 0,
  tipOption2: 0,
  tipOption3: 0,
  displayDefaultModifiers: false,
  hideModGroupTitles: false,
  groupSameModItems: false,
  addSubForMultiSelectOff: false,
  noForDeselectedDefaultModifiers: false,
  ticketHeader: GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  ticketFooter: GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE,
  showLogo: false,
  courseOrder: [],
  modifierItemDisplayMode: "vertical" /* VERTICAL */,
  sortItemsBy: "registerCourse" /* REGISTER_COURSE */,
  secondSortItemsBy: "alphabetical" /* ALPHABETICAL */,
  fontSize: "a11" /* A11 */,
  printZeroForFreeModItems: false,
  printMerchantCopy: true,
  onlyPrintModItemsWithPrice: false,
  showItemUnitPrice: false,
  taxIndicatorPosition: "Before" /* BEFORE */,
  taxIndicatorColor: "black" /* BLACK */,
  taxIndicator: null,
  taxExemptIndicator: null,
  showTaxIndicator: false,
  spaceBetweenItems: "0" /* ZERO */,
  fontWeight: "normal" /* NORMAL */,
  customTypeNameDineIn: null,
  customTypeNameCurbside: null,
  customTypeNameToGo: null,
  customTypeNameDelivery: null,
  customTypeNamePickup: null,
  showTaxesIndividually: false,
  printOrderQr: false
};
var PREP_STATIONS_SETTINGS_INITIAL_STATE = {
  prepStations: {},
  defaultPrepStationId: null
};
var PRINTER_RULE_SETTINGS_INITIAL_STATE = {
  licenseId: 0,
  daysOfWeek: "monday,tuesday,wednesday,thursday,friday,saturday,sunday",
  endTime: "2023-12-25T23:59:00.000Z",
  id: "",
  name: "",
  order: 0,
  orderType: null,
  serviceAreaId: null,
  startTime: "2023-12-25T00:00:00.000Z",
  fromPrepStationId: -1,
  toPrepStationId: -1,
  locationId: 0
};
var TAX_SETTING_INITIAL_STATE = {
  id: 0,
  name: "",
  orderTypes: `${"catering" /* CATERING */},${"dine in" /* DINE_IN */},${"delivery" /* DELIVERY */},${"to_go" /* TO_GO */}`,
  taxType: "percent" /* PERCENT */,
  tableTypeData: null,
  typeData: {
    unit: null,
    interval: null,
    rate: 0
  }
};
var USERS_SETTINGS_INITIAL_STATE = {};
var PRINTER_RULES_SETTINGS_INITIAL_STATE = {
  0: PRINTER_RULE_SETTINGS_INITIAL_STATE
};
var LICENSE_SPECIFIC_PRINTER_RULES_SETTINGS_INITIAL_STATE = {};
var TABLETS_INITIAL_STATE = {};
var PRINTERS_INITIAL_STATE = {};
var TERMINALS_INITIAL_STATE = {};
var PREP_STATION_INITIAL_STATE = {
  id: 0,
  active: true,
  name: "",
  posName: "",
  printerIds: []
};
var PRINTER_INITIAL_STATE = {
  name: "",
  organizationId: 0,
  backupPrinterId: 0,
  macAddress: "",
  prepStationId: 0,
  locationId: 0,
  prepStation: PREP_STATION_INITIAL_STATE,
  serialNumber: "",
  make: "",
  model: "",
  paperWidth: 0,
  status: "active" /* ACTIVE */,
  type: "kitchen" /* KITCHEN */,
  dpi: 0,
  id: 0,
  showInPrinterCenter: true
};
var TERMINAL_INITIAL_STATE = {
  id: 0,
  name: "",
  tpn: "",
  authKey: "",
  authToken: "",
  licenseIds: [],
  organizationId: 0,
  locationId: 0
};
var DEVICES_INITIAL_STATE = {
  tablets: TABLETS_INITIAL_STATE,
  printers: PRINTERS_INITIAL_STATE,
  terminals: TERMINALS_INITIAL_STATE
};
var LICENSE_INITIAL_STATE = {
  licenseType: "",
  purchaseDate: "0001-01-01T00:00:00Z",
  activationDate: "0001-01-01T00:00:00Z",
  status: "inactive",
  deviceId: 0,
  licenseSettingsId: 0,
  organizationId: 0,
  activationCode: "222222",
  locationId: 0,
  licenseSerial: "",
  id: 0
};
var LICENSES_INITIAL_STATE = {
  0: LICENSE_INITIAL_STATE
};
var LICENSES_SETTINGS_INITIAL_STATE = {
  0: LICENSE_SETTINGS_INITIAL_STATE
};
var TAXES_SETTINGS_INITIAL_STATE = {
  0: TAX_SETTING_INITIAL_STATE
};
var REGISTER_DISCOUNT_REASON_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  locationId: 0,
  discountReasonId: 0,
  posName: "",
  active: true,
  sortPriority: 0,
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  isDiscount: true,
  isVoid: true
});
var REGISTER_SPECIAL_TAG_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  name: "",
  posName: "",
  specialTagId: 0,
  color: null,
  textColor: null,
  abbreviation: "",
  organizationId: 0,
  locationId: 0,
  active: true
});
var REGISTER_ORDER_SEAT_TAG_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  organizationId: 0,
  createdByLocationId: null,
  name: "",
  type: null,
  locationId: null,
  orderSeatTagId: 0,
  posName: "",
  backgroundColor: null,
  textColor: null,
  active: true,
  isOrderTag: false,
  isSeatTag: false,
  sortPriority: 1,
  orderTagFavorite: false,
  seatTagFavorite: false
});
var PAYMENTS_CUSTOM_TENDER_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  locationId: 0,
  customTenderId: 0,
  backgroundColor: null,
  textColor: null,
  active: true,
  sortPriority: 1,
  allowsTips: false,
  autoConfirmTip: false,
  printReceipt: false,
  printMerchantCopy: false,
  printTipTotalLines: false
});
var REGISTER_MODIFIER_TAG_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  locationId: 0,
  modifierTagId: 0,
  posName: "",
  checkName: "",
  active: true,
  sortPriority: 0,
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  tagPosition: "after" /* AFTER */,
  textColor: null,
  backgroundColor: null,
  isSpecial: false,
  menuTypeIds: null
});
var REGISTER_OPEN_ITEM_TYPE_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  locationId: 0,
  openItemTypeId: 0,
  posName: "",
  active: true,
  sortPriority: 0,
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  dontPromptOpenItemName: false,
  prepStationId: 0,
  taxIds: [],
  reportingGroupsIds: []
});
var REGISTER_AD_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID), {
  active: true,
  sortPriority: 0,
  imageUrl: null,
  title: "",
  text: "",
  price: 0
});
var REGISTER_MENU_TYPE_SERVICE_TIME_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  menuTypeId: 0,
  registerSettingsId: 0,
  day: "monday" /* MONDAY */,
  startTime: "",
  endTime: ""
});
var GENERAL_SETTINGS_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  organizationId: 0,
  locationId: 0,
  serviceType: "tsr",
  timeZone: "utc",
  endOfBusinessDay: "",
  clockInMode: "manual" /* MANUAL */,
  operationalDayHours: OPERATIONAL_DAY_HOURS_INITIAL_STATE,
  name: "",
  websiteUrl: "",
  digitalLogoUrl: "",
  printLogoUrl: "",
  streetLine1: "No street",
  streetLine2: "No street",
  city: "---",
  state: "---",
  postalCode: "---",
  country: "---",
  phoneNumber: "",
  email: "",
  pinpadLayout: "calculator" /* CALCULATOR */,
  allowUserToBeLoggedIntoMultipleTablets: false
});
var ONLINE_MENU_TIME_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  menuTypeId: 0,
  startTime: "",
  endTime: ""
});
var ONLINE_AVAILABILITY_TIME_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE_WITH_STRING_ID), {
  startTime: "",
  endTime: ""
});
var ONLINE_ORDERING_SETTINGS_INITIAL_STATE = __spreadProps(__spreadValues({}, INITIAL_STATE_BASE_INTERFACE), {
  acceptingOrders: true,
  pickupIsActive: true,
  pickupBufferTime: 5,
  pickupTipDefault: 0,
  pickupTip1: 10,
  pickupTip2: 15,
  pickupTip3: 20,
  deliveryIsActive: true,
  deliveryBufferTime: 5,
  deliveryTipDefault: 0,
  deliveryTip1: 10,
  deliveryTip2: 15,
  deliveryTip3: 20,
  deliveryRadius: 0,
  copyPickupTimes: true,
  showTippingAtCheckout: true,
  primaryColor: "",
  secondaryColor: "",
  tertiaryColor: "",
  backgroundColor: "",
  showBanner: false,
  bannerDescription: "",
  showItemImage: true,
  allowSpecialInstructionsOnItems: true,
  showCalories: false,
  scheduleOutOrder: 7,
  defaultMenuTypeId: 0,
  onlineMenuTimes: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  },
  pickupAvailability: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  },
  deliveryAvailability: {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }
});
var SETTINGS_INITIAL_STATE = {
  lockScreen: LOCK_SCREEN_SETTINGS_INITIAL_STATE,
  general: GENERAL_SETTINGS_INITIAL_STATE,
  online: ONLINE_ORDERING_SETTINGS_INITIAL_STATE,
  roles: ROLES_INITIAL_STATE,
  register: REGISTER_SETTINGS_INITIAL_STATE,
  registerTicket: TICKET_SETTINGS_INITIAL_STATE,
  kitchenTicket: KITCHEN_TICKET_SETTINGS_INITIAL_STATE,
  prepStations: PREP_STATIONS_SETTINGS_INITIAL_STATE,
  users: USERS_SETTINGS_INITIAL_STATE,
  printerRules: PRINTER_RULES_SETTINGS_INITIAL_STATE,
  licenseSpecificPrinterRules: LICENSE_SPECIFIC_PRINTER_RULES_SETTINGS_INITIAL_STATE,
  devices: DEVICES_INITIAL_STATE,
  licenses: LICENSES_INITIAL_STATE,
  licenseSettings: LICENSES_SETTINGS_INITIAL_STATE,
  taxes: TAXES_SETTINGS_INITIAL_STATE,
  guestCheck: GUEST_CHECK_SETTINGS_INITIAL_STATE,
  guestReceipt: GUEST_RECEIPT_SETTINGS_INITIAL_STATE,
  payments: PAYMENTS_SETTINGS_INITIAL_STATE,
  dashboards: DASHBOARDS_INITIAL_STATE
};
var LOCATION_SETTINGS_INITIAL_STATE = {
  lockScreen: LOCK_SCREEN_SETTINGS_INITIAL_STATE,
  general: GENERAL_SETTINGS_INITIAL_STATE,
  online: ONLINE_ORDERING_SETTINGS_INITIAL_STATE,
  roles: ROLES_INITIAL_STATE,
  register: REGISTER_SETTINGS_INITIAL_STATE,
  registerTicket: TICKET_SETTINGS_INITIAL_STATE,
  kitchenTicket: KITCHEN_TICKET_SETTINGS_INITIAL_STATE,
  prepStations: PREP_STATIONS_SETTINGS_INITIAL_STATE,
  users: USERS_SETTINGS_INITIAL_STATE,
  printerRules: PRINTER_RULES_SETTINGS_INITIAL_STATE,
  licenseSpecificPrinterRules: LICENSE_SPECIFIC_PRINTER_RULES_SETTINGS_INITIAL_STATE,
  devices: DEVICES_INITIAL_STATE,
  licenses: LICENSES_INITIAL_STATE,
  licenseSettings: LICENSES_SETTINGS_INITIAL_STATE,
  taxes: TAXES_SETTINGS_INITIAL_STATE,
  guestCheck: GUEST_CHECK_SETTINGS_INITIAL_STATE,
  guestReceipt: GUEST_RECEIPT_SETTINGS_INITIAL_STATE,
  payments: PAYMENTS_SETTINGS_INITIAL_STATE,
  dashboards: DASHBOARDS_INITIAL_STATE
};
var SELECTED_MODE_INITIAL_STATE = {
  settingsType: "location" /* LOCATION_SETTINGS */,
  id: 0,
  currentSettings: SETTINGS_INITIAL_STATE,
  settingsVersion: 0,
  name: "Location"
};
var WEEK_COPY_INITIAL_SELECTED_DAYS = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false
};
var HOME_SCREEN_PERMISSIONS_INITIAL_STATE = {
  registerModuleAvailable: false,
  menuModuleAvailable: false,
  settingsModuleAvailable: false,
  managementModuleAvailable: false,
  reportsModuleAvailable: false,
  registerModuleDefault: false,
  menuModuleDefault: false,
  customersModuleDefault: false,
  customersModuleAvailable: false,
  settingsModuleDefault: false,
  managementModuleDefault: false,
  reportsModuleDefault: false
};
var getSettingsInitialState = (settingsSelected) => {
  switch (settingsSelected) {
    case "roles": {
      return ROLE_INITIAL_STATE;
    }
    case "users": {
      return USER_INITIAL_STATE;
    }
    case "licenseSettings": {
      return LICENSE_SETTINGS_INITIAL_STATE;
    }
  }
};

export { DAY_OPERATIONAL_HOURS_INITIAL_STATE, GUEST_CHECK_CUSTOMIZING_RECEIPT_INITIAL_STATE, HOME_SCREEN_PERMISSIONS_INITIAL_STATE, KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_INITIAL_STATE, KITCHEN_TICKET_CUSTOMIZING_RECEIPT_BODY_ROW_INITIAL_STATE, KITCHEN_TICKET_CUSTOMIZING_RECEIPT_INITIAL_STATE, KITCHEN_TICKET_CUSTOMIZING_RECEIPT_ROW_INITIAL_STATE, KITCHEN_TICKET_PREP_STATION_VERSION, LICENSES_SETTINGS_INITIAL_STATE, LICENSE_INITIAL_STATE, LOCATION_SETTINGS_INITIAL_STATE, ONLINE_AVAILABILITY_TIME_INITIAL_STATE, ONLINE_MENU_TIME_INITIAL_STATE, OPERATIONAL_DAY_HOURS_INITIAL_STATE, PAYMENTS_CUSTOM_TENDER_INITIAL_STATE, PREP_STATION_INITIAL_STATE, PRINTER_INITIAL_STATE, PRINTER_RULE_SETTINGS_INITIAL_STATE, REGISTER_AD_INITIAL_STATE, REGISTER_DISCOUNT_REASON_INITIAL_STATE, REGISTER_MENU_TYPE_SERVICE_TIME_INITIAL_STATE, REGISTER_MODIFIER_TAG_INITIAL_STATE, REGISTER_OPEN_ITEM_TYPE_INITIAL_STATE, REGISTER_ORDER_SEAT_TAG_INITIAL_STATE, REGISTER_SPECIAL_TAG_INITIAL_STATE, SELECTED_MODE_INITIAL_STATE, SETTINGS_INITIAL_STATE, TAXES_SETTINGS_INITIAL_STATE, TAX_SETTING_INITIAL_STATE, TERMINAL_INITIAL_STATE, WEEK_COPY_INITIAL_SELECTED_DAYS, getSettingsInitialState };
